import { Box, Button, Icon, Popover } from '@mui/material'
import Grid from '@mui/material/Grid'
import { SimpleTreeView } from '@mui/x-tree-view'
import classNames from 'classnames'
import React, { PropsWithChildren, ReactElement, useEffect } from 'react'
import PopoverCloseButton from 'ui/components/PopoverCloseButton/PopoverCloseButton'

import styles from './TreeDropdown.module.less'

type TreeDropdownProps = {
  customButtonTitle: string
  handleToggle?: (open: boolean) => void
}

export default function TreeDropdown({
  children,
  customButtonTitle,
  handleToggle,
}: PropsWithChildren<TreeDropdownProps>): ReactElement {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = (): void => {
    setAnchorEl(null)
  }
  const open = Boolean(anchorEl)

  useEffect(() => {
    if (handleToggle) {
      handleToggle(open)
    }
  }, [handleToggle, open])

  return (
    <>
      <Button onClick={handleClick} className={styles.TreeDropdown_Button}>
        <Icon className={classNames(`fas fa-info-circle`, styles.TreeDropdown_Icon)} fontSize="inherit" />
        <div className={styles.TreeDropdown_Text}>{customButtonTitle}</div>
      </Button>
      {open && (
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          style={{ overflow: `scroll` }}
          anchorOrigin={{
            vertical: `bottom`,
            horizontal: `center`,
          }}
          transformOrigin={{
            vertical: `top`,
            horizontal: `center`,
          }}
        >
          <Grid container direction="row" justifyContent="flex-end" className={styles.TreeDropdown_CloseButton}>
            <PopoverCloseButton handleClose={handleClose} />
          </Grid>

          <Grid container direction="column" className={styles.TreeDropdown_Settings}>
            <Box sx={{ minWidth: 250 }}>
              <SimpleTreeView>{children}</SimpleTreeView>
            </Box>
          </Grid>
        </Popover>
      )}
    </>
  )
}
